import React from 'react'
import MacroAccordion from '../components/Macros/Accordion'

function AccordionListMacro({ accordionLists }) {
  return accordionLists && accordionLists.map((accordionItem, i) => (
    <MacroAccordion
      key={'accordion-list-' + i}
      theme={accordionItem.type === 'success-stories' ? 'dark' : 'light'}
      heading={accordionItem.heading}
      accordion={accordionItem.accordion}
    />
  ))
}

export default (props) => <AccordionListMacro {...props} />
